// extracted by mini-css-extract-plugin
export default {"header":"Layout_header__zwfg9","container":"Layout_container__dVyML","containerFullscreen":"Layout_containerFullscreen__STdwG"};